import { IColumn } from "../interfaces/table";

export const ConfigTextDefaults = {
  kursus: {
    DELTAGER_MAX: 48,
  },
  linje: {
    DELTAGER_MAX: 48,
  },
};

export const ConfigOpretRetteDefaults: IColumn<any>[] = [
  { field: "opretDato", title: "Oprettet", active: false, format: "date" },
  { field: "opretInit", title: "Oprettet af", active: false, format: "string" },
  { field: "retteDato", title: "Rettet", active: false, format: "date" },
  { field: "retteInit", title: "Rettet af", active: false, format: "string" },
];

export const ConfigDefaults: IColumn<any>[] = [
  { field: "id", title: "Id", active: false, format: "string" },
  ...ConfigOpretRetteDefaults,
];

export const ConfigKursusGruppe = {
  badge: {
    className: {
      1: "badge badge-pink rounded-pill",
      2: "badge badge-violet rounded-pill",
      3: "badge badge-blue rounded-pill",
      4: "badge badge-teal rounded-pill",
      5: "badge badge-green rounded-pill",
      6: "badge badge-yellow rounded-pill",
      7: "badge badge-orange rounded-pill",
      8: "badge badge-red rounded-pill",
    },
  },
};
